import React from 'react';
import {
  Card,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import useStyles from './../styles';


const RequestPromotionBuyXGetY = ({
  values,
  setFieldValue,
  touched,
  errors
}) => {
  const classes = useStyles();

  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        Minimum Order to Qualify <span className="text-error">*</span>
      </Typography>
      <FormControl component="fieldset" className="w-full">
        <RadioGroup
          name="minOrderAmount"
          value={values.minOrderAmount.name}
          onChange={(event) => {
            setFieldValue('minOrderAmount.name', event.target.value);
          }}
        >
          <FormControlLabel
            value="None"
            control={
              <Radio
                size="small"
                color="primary"
                onClick={() => setFieldValue('minOrderAmount.value', '')}
              />
            }
            label="None"
          />
          <FormControlLabel
            value="Purchase Amount"
            control={
              <Radio
                size="small"
                color="primary"
                onClick={() => setFieldValue('minOrderAmount.value', '')}
              />
            }
            label={
              <div className="flex items-center">
                <div className="whitespace-no-wrap">Purchase Amount</div>
                {values.minOrderAmount.name === 'Purchase Amount' &&
                <NumberFormat
                  customInput={TextField}
                  prefix={'$'}
                  required
                  size="small"
                  placeholder="$"
                  variant="outlined"
                  name="minOrderAmount.value"
                  className={`ml-4 w-full ${classes.custom_input}`}
                  value={values.minOrderAmount.value}
                  onValueChange={(value) => {
                    setFieldValue('minOrderAmount.value', value.formattedValue);
                  }}
                  error={touched.minOrderAmount?.value && Boolean(errors.minOrderAmount?.value)}
                  helperText={touched.minOrderAmount?.value && errors.minOrderAmount?.value}
                />
                }
              </div>
            }
          />
          <FormControlLabel
            value="Quantity"
            control={
              <Radio
                size="small"
                color="primary"
                onClick={() => setFieldValue('minOrderAmount.value', '')}
              />
            }
            label={
              <div className="flex items-center">
                <div className="whitespace-no-wrap">Quantity</div>
                {values.minOrderAmount.name === 'Quantity' &&
                <NumberFormat
                  customInput={TextField}
                  required
                  size="small"
                  variant="outlined"
                  name="minOrderAmount.value"
                  className={`ml-4 w-full ${classes.custom_input}`}
                  value={values.minOrderAmount.value}
                  onValueChange={(value) => {
                    setFieldValue('minOrderAmount.value', value.formattedValue);
                  }}
                  error={touched.minOrderAmount?.value && Boolean(errors.minOrderAmount?.value)}
                  helperText={touched.minOrderAmount?.value && errors.minOrderAmount?.value}
                />
                }
              </div>
            }
          />
          {touched.minOrderAmount?.name && Boolean(errors.minOrderAmount?.name) &&
          <FormHelperText>
            <Typography color="error" variant="caption">
              {errors.minOrderAmount.name}
            </Typography>
          </FormHelperText>
          }
        </RadioGroup>
      </FormControl>
    </Card>
  );
};

export default RequestPromotionBuyXGetY;
